<template>
    <div class="register-term-page">
        <top-bar class="topbar"></top-bar>

        <div class="term-page">
            <div class="chanel-head">
                <div class="head1">ลงทะเบียนกับชาเนล เพื่อรับข่าวสารจากแบรนด์</div>
                <!-- <div> ข้อมูลอีเว้นท์ ผลิตภัณฑ์ขนาดทดลอง และบริการต่างๆ</div> -->
            </div>
            <div class="term-wrapper">

                <div class="detail-term">
                    <div>
                        <div class="content" v-html="content"></div>
                    </div>
                </div>
                <div class="blur-text"></div>
            </div>
            <div class="accept-wrapper">
                <div class="icon" @click="clickAcceptAge()">
                    <img v-show="isAcceptAge" src="@/assets/img/radio_active.png">
                    <img v-show="!isAcceptAge" src="@/assets/img/radio_unactive.png">
                </div>
                <div class="text">
                    ข้าพเจ้ายืนยันว่ามีอายุอย่างน้อย 20 ปีขึ้นไป
                </div>
            </div>
            <div class="accept-wrapper">
                <div class="icon" @click="clickAcceptTerm()">
                    <img v-show="isAccept" src="@/assets/img/radio_active.png">
                    <img v-show="!isAccept" src="@/assets/img/radio_unactive.png">
                </div>
                <div class="text">
                    ข้าพเจ้าประสงค์รับการสื่อสารการตลาดทางตรงตามที่กำหนดไว้ในคำชี้แจงด้านการเก็บข้อมูลส่วนบุคคลข้างต้น ผ่านทางอีเมล โทรศัพท์ สื่อสังคมออนไลน์ ข้อความสั้น ข้อความโต้ตอบแบบทันที ไปรษณีย์ และวิธีอื่นใดที่ข้าพเจ้าอาจให้ความยินยอมเป็นครั้งคราว
                </div>
            </div>
            <div class="btn-accept-term">
                <button class="btn btn-primary btn-custom-dark"
                    :class="{'disable-btn': !isAccept || !isAcceptAge}" @click="requestOtp()"> ตกลง </button>
            </div>


        </div>

        <b-modal
            :id="modalAlert.id"
            modal-class="modal-alert alert-term-modal"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-alert-wrapper">
                <div class="modal-base-wrapper">
                    <div class="modal-base alert-body">
                        <div class="modal-base-head"></div>
                        <div class="modal-base-body">
                            <div class="text-error">
                                <p>
                                    กรุณากดยืนยันคำชี้แจ้งการเก็บรักษาข้อมูลส่วนบุคคล
                                </p>
                                <button
                                    class="btn btn-primary btn-custom-dark"
                                    @click="clickOkModalAlert();">
                                    ตกลง
                                </button>
                            </div>
                        </div>
                        <div class="modal-base-footer"></div>
                    </div>
                </div>
            </div>
        </b-modal>

    </div>
</template>
<script>

import TopBar from "@/components/TopBar.vue";
import { TrackingService } from "@/helper/TrackingHelper.js";
import BzbsPDPA from "@/service/BzbsPDPA";
import Locale from "@/helper/locale/locale.js";

export default {
name: "TermComponent",
    props: {
        view: String,
        busModalTerm: Object
    },
    components: {
        TopBar,
    },
    data: function() {
        return {

            isAccept: false,
            isAcceptAge: false,
            registerdata: "",
            modalAlert: {
                id: "modal-term-alert-",
                title: "ss",
                strBtnOk: "",
                message: "",
                tag: ""
            },
            modalConfirm: {
                id: "modal-term-confirm-",
                title: "",
                strBtnOk: "",
                strBtnCancel: "",
                message: "",
                tag: "",
                isChecked: false,
                triggerConsentModal: true
            },
            content: "",
            tracking: new TrackingService(this),
            localeCode: Locale.getLocaleCode(),
        };
    },
    created: function() {

        this.tracking.screenName("regis_consent");
        this.tracking.event("regis_consent", "view_consent");

        this.modalAlert.id += this.view;
        this.modalConfirm.id += this.view;
        this.getTermsAndConditions()
    },
    mounted: function() {
        this.busModalTerm.$on('setPhoneNumber', this.setPhoneNumber);
        this.busModalTerm.$on("showAlertModal", this.showModalAlert);
        this.busModalTerm.$on("hideAlertModal", this.hideModalAlert);

        this.busModalTerm.$on("showConfirmModal", this.showModalConfirm);
        this.busModalTerm.$on("hideConfirmModal", this.hideModalConfirm);

    },
    methods: {
        getTermsAndConditions:function(){
            BzbsPDPA.apiGetPDPAContent(this.localeCode).then(res=>{
                if(res.data){
                    console.log(res)
                    this.content = res.data
                    console.log("Terns Content : ", this.content)
                }
            })
        },
        setPhoneNumber: function (config) {
            this.registerdata = config;

            this.$nextTick(() => {

			    window.scrollTo(0, 0);
		    });

        },
        requestOtp: function () {

            this.tracking.event("regis_consent", "click_next_to_otp");
            if (!this.isAccept) {
                this.showModalAlert();
                return;
            }

            var objRegisterconfig = {
                // display_contac_number: this.displayContactNumber,
                registerdata: this.registerdata,
                tag: 'register_otp',
            }

            this.$emit('onClicknext', objRegisterconfig);
        },
        clickAcceptAge: function () {
            this.isAcceptAge = !this.isAcceptAge;
        },
        clickAcceptTerm: function () {

            this.tracking.event("regis_consent", "click_agree_conset");
            this.isAccept = !this.isAccept;
        },

        showModalConfirm: function() {
            this.modalConfirm.title = "";
            this.modalConfirm.message = "";
            this.modalConfirm.strBtnOk = "ถัดไป";
            this.modalConfirm.strBtnCancel = "Cancel";
            this.modalConfirm.tag = "";

            this.$bvModal.show(this.modalConfirm.id);
        },

        showModalAlert: function() {
            this.modalAlert.title = "";
            this.modalAlert.message = "";
            this.modalAlert.strBtnOk = "Ok";
            this.modalAlert.tag = "";
            this.$bvModal.show(this.modalAlert.id);
        },
        clickOkModalAlert: function() {

            this.tracking.event("regis_consent", "click_popup_confirm_consent");
            this.$bvModal.hide(this.modalAlert.id);
        },
    }

}
</script>
<style lang="scss" scoped>

    @import "ModalAlert.scss";
    @import "TermComponent.scss";
</style>
